module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area03_img_en.cac91f12.png";